export enum ERequestStatus {
    success = 'success',
    error = 'error',
    notRequest = 'not-request',
}
